import React from 'react';
import PropTypes from 'prop-types';
import UiComponent from '../UiComponent';

class Input extends UiComponent {

  constructor(props) {
    super(props);
    this.changeValue = this.changeValue.bind(this);
    this.onRender = this.onRender.bind(this);
  }


  changeValue(value) {
    this.props.field.value = value;
    if (this.props.relatedTo && this.props.relatedTo.length > 0) {
      this.props.onChange([
          this.props.relatedTo,
          this.props.field.name,
        ],
        this.props.field
      );
    } else {
      this.props.onChange(this.props.field.name, this.props.field);
    }
  }

  onRender(type, elem) {
    if (this.props.onRender) {
      return this.props.onRender({type, elem});
    }

    return elem;
  }

  render() {
    const containerClass = `form-group ${this.props.className || ''}`;
    let disabled = false;
    if (this.getFieldProp('system') && this.getFieldProp('system').disabled) {
      disabled = true;
    }
    return (
      <div className={containerClass}>
        {this.onRender('label', this.getLabel())}
        {this.onRender('input', (<input
          autoComplete="off"
          type={this.getFieldProp('type')}
          className={this.props.small ? "form-control form-control-small" : "form-control"}
          placeholder={this.getFieldProp('placeholder')}
          onChange={e => this.changeValue(e.target.value)}
          value={this.getFieldProp('value')}
          disabled={disabled || this.props.disabled}
        />))}
        {this.onRender('error', this.getErrors())}
      </div>
    );
  }
}

Input.propTypes = {
  relatedTo: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  label: PropTypes.object,
  field: PropTypes.object,
  onChange: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  small: PropTypes.bool
};

Input.defaultProps = {
  small: false
}


export default Input;



// WEBPACK FOOTER //
// ./src/common/Input/index.js